import { render, staticRenderFns } from "./BankAccountCreate.vue?vue&type=template&id=49d445ee"
import script from "./BankAccountCreate.vue?vue&type=script&lang=js"
export * from "./BankAccountCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports